/* assets/cart-progress-bar.js */
function updateBar(cart){
  const threshold = window.freeShippingThreshold || 4500;             // ¢
  const pct       = Math.min(100, cart.total_price / threshold * 100);
  console.log(cart)
  document.querySelectorAll('.cart-threshold__fill')
          .forEach(el => el.style.width = pct + '%');

  document.querySelectorAll('.cart-threshold__text')
          .forEach(el => {
            el.textContent = cart.total_price >= threshold
              ? '🎉 You’ve unlocked free shipping!'
              : `Spend $${((threshold - cart.total_price) / 100).toFixed(0)} more for free shipping`;
          });
}

/* Primary hook (Impulse ≥ v3.5) */
document.addEventListener('cart:updated',  e => updateBar(e.detail.cart));

/* Fallback for adds on very old theme versions */
document.addEventListener('ajaxProduct:added', () => {
  fetch('/cart.js').then(r => r.json()).then(updateBar);
});
